import { supabaseAEC as supabase } from './supabaseAEC';

/**
 * Fetch published resources, optionally filtered by category.
 * @param {{ category?: string|null }} options
 * @returns {Promise<Array>}
 */
export async function fetchResources({ category = null } = {}) {
  let query = supabase
    .from('resources')
    .select('*')
    .eq('status', 'published')
    .order('published_at', { ascending: false });

  if (category) {
    query = query.eq('category', category);
  }

  const { data, error } = await query;
  if (error) throw error;
  return data ?? [];
}

/**
 * Fetch a single published resource by slug.
 * @param {string} slug
 * @returns {Promise<Object>}
 */
export async function fetchResourceBySlug(slug) {
  const { data, error } = await supabase
    .from('resources')
    .select('*')
    .eq('slug', slug)
    .eq('status', 'published')
    .single();
  if (error) throw error;
  return data;
}
